import { elements, html, ref, repeat, slotted } from '@microsoft/fast-element';

import type { Carousel } from './carousel.js';

export default html<Carousel>`
	<adaptive-flipper
		class="previous"
		aria-controls="scroll-container"
		aria-label="go to previous slide"
		direction="previous"
		@click=${x => x.previous()}
		?hidden=${x => x.activeId === x.items?.[0]?.id}
		?inert=${x => x.activeId === x.items?.[0]?.id}
	></adaptive-flipper>

	<div
		${ref('scrollContainer')}
		id="scroll-container"
		class="scroll-container"
		aria-live="polite"
	>
		<div class="end-cap"></div>
		<slot ${slotted({ property: 'items', filter: elements() })}></slot>
		<div class="end-cap"></div>
	</div>

	<adaptive-flipper
		class="next"
		aria-controls="scroll-container"
		aria-label="go to next slide"
		direction="next"
		@click=${x => x.next()}
		?hidden=${x => x.activeId === x.items?.[x.items.length - 1]?.id}
		?inert=${x => x.activeId === x.items?.[x.items.length - 1]?.id}
	></adaptive-flipper>

	<div
		${ref('paginationContainer')}
		class="pagination-container"
		role="tablist"
	>
		${repeat(x => x.createPagination(), html`${x => x}`)}
	</div>
`;